import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'

const AddAddressModal = ({
  data,
  onClose,
  onSave,
  onUpdate,
  isShippingChargesEnabled = false,
  statesData = [],
}) => {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    city: '',
    state: '',
    zipcode: '',
    country: '',
    phone: '',
    default: false,
  })
  const [errorData, setErrorData] = useState({})

  // Animation state
  const [show, setShow] = useState(false)

  // Show modal with delay on mount
  useEffect(() => {
    setTimeout(() => setShow(true), 10)
  }, [])

  useEffect(() => {
    if (!isEmpty(data)) {
      setFormData(data)
    }
  }, [data])

  const handleClose = () => {
    setShow(false)
    setTimeout(() => {
      onClose()
    }, 400)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setErrorData((prev) => ({
      ...prev,
      [name]: '',
    }))
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (formData.name.trim().length === 0) {
      isFormValid = false
      temp.name = `name cannot be empty!`
    }
    if (formData.address.trim().length === 0) {
      isFormValid = false
      temp.address = `address cannot be empty!`
    }
    if (formData.city.trim().length === 0) {
      isFormValid = false
      temp.city = `city cannot be empty!`
    }
    if (formData.state.trim().length === 0) {
      isFormValid = false
      temp.state = `state cannot be empty!`
    }
    if (formData.zipcode.trim().length === 0) {
      isFormValid = false
      temp.zipcode = `zipcode cannot be empty!`
    }
    if (formData.country.trim().length === 0) {
      isFormValid = false
      temp.country = `country cannot be empty!`
    }
    if (formData.phone.trim().length === 0) {
      isFormValid = false
      temp.phone = `phone cannot be empty!`
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSubmit = (e) => {
    if (!validateInfo()) return
    e.preventDefault()

    if (!isEmpty(data)) {
      onUpdate(formData)
      return
    }
    onSave(formData)
  }

  return (
    <div
      style={{
        backgroundColor: '#00000070',
        opacity: show ? 1 : 0,
        transition: 'opacity 0.4s ease',
      }}
      className="fixed inset-0 flex items-center justify-center z-50"
    >
      <div
        style={{
          color: '#e3e2e2',
          backgroundColor: '#1d2a39',
          transform: show ? 'scale(1)' : 'scale(0.9)',
          opacity: show ? 1 : 0,
          transition: 'all 0.4s ease',
        }}
        className="rounded-[10px] w-11/12 md:w-9/12 lg:w-1/2 xl:w-2/5  2xl:w-[36%] p-8"
      >
        <p className="text-base text-white font-semibold mb-5">Add a new address</p>
        <div className="flex flex-col gap-3">
          <input
            type="text"
            placeholder={errorData?.name ? errorData?.name : 'Full Name'}
            className="p-2 rounded bg-transparent border text-sm"
            value={formData.name}
            name="name"
            onChange={handleChange}
            style={{ border: `solid 0.5px ${errorData?.name ? 'red' : '#979797'} ` }}
          />
          <textarea
            placeholder={errorData?.address ? errorData?.address : 'Address (Area and Street)'}
            name="address"
            className="p-2 rounded bg-transparent border text-sm"
            style={{ border: `solid 0.5px ${errorData?.address ? 'red' : '#979797'} ` }}
            value={formData.address}
            onChange={handleChange}
          />
          <input
            type="text"
            name="city"
            placeholder={errorData?.city ? errorData?.city : 'City'}
            className="p-2 rounded bg-transparent border text-sm"
            style={{ border: `solid 0.5px ${errorData?.city ? 'red' : '#979797'} ` }}
            value={formData.city}
            onChange={handleChange}
          />
          {isShippingChargesEnabled ? (
            <select
              className="p-2 rounded bg-transparent border text-sm"
              name="state"
              style={{ border: `solid 0.5px ${errorData?.state ? 'red' : '#979797'} ` }}
              value={formData.state}
              onChange={handleChange}
            >
              <option value="" disabled selected>
                Select State
              </option>
              {statesData.map((state, index) => (
                <option key={index} value={state}>
                  {state}
                </option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              name="state"
              placeholder={errorData?.state ? errorData?.state : 'State'}
              className="p-2 rounded bg-transparent border text-sm"
              style={{ border: `solid 0.5px ${errorData?.state ? 'red' : '#979797'} ` }}
              value={formData.state}
              onChange={handleChange}
            />
          )}
          <input
            type="text"
            name="zipcode"
            placeholder={errorData?.zipcode ? errorData?.zipcode : 'Zip code/ Pin code'}
            className="p-2 rounded bg-transparent border text-sm"
            style={{ border: `solid 0.5px ${errorData?.zipcode ? 'red' : '#979797'} ` }}
            value={formData.zipcode}
            onChange={handleChange}
          />
          <input
            type="text"
            placeholder={errorData?.country ? errorData?.country : 'Country'}
            name="country"
            className="p-2 rounded bg-transparent border text-sm"
            style={{ border: `solid 0.5px ${errorData?.country ? 'red' : '#979797'} ` }}
            value={formData.country}
            onChange={handleChange}
          />
          <input
            type="number"
            placeholder={errorData?.phone ? errorData?.phone : 'Phone Number'}
            name="phone"
            className="p-2 rounded bg-transparent border text-sm "
            style={{ border: `solid 0.5px ${errorData?.phone ? 'red' : '#979797'} ` }}
            value={formData.phone}
            onChange={handleChange}
          />
          <div className="flex justify-end gap-3 mt-5">
            <button
              type="button"
              className="px-6 py-2 rounded text-sm"
              style={{ border: '1px solid #f60', color: '#e3e2e2' }}
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-2 rounded text-sm"
              style={{
                backgroundImage: 'linear-gradient(95deg, #f60 7%, #ff4e00 97%)',
              }}
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddAddressModal
